var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "lifetime-section-wrapper" }, [
    _c("div", { staticClass: "text-wrapper" }, [
      _c("div", { staticClass: "icon" }, [
        _c("img", {
          attrs: {
            src: require("@/assets/img/pricing/lifetime-deal/aiAssistanceIcon.svg"),
            alt: "ai-assistance-icon",
          },
        }),
        _c("span", [_vm._v(_vm._s(_vm.$t("aiAssistance.title")))]),
      ]),
      _c("div", { staticClass: "title font-outfit-semi-bold" }, [
        _vm._v(" " + _vm._s(_vm.$t("aiAssistanceSection.title")) + " "),
      ]),
      _c("div", { staticClass: "text" }, [
        _c("p", { staticClass: "font-outfit-regular" }, [
          _vm._v(" " + _vm._s(_vm.$t("aiAssistanceSection.text")) + " "),
        ]),
      ]),
    ]),
    _vm._m(0),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "image-wrapper" }, [
      _c("img", {
        attrs: {
          src: require("@/assets/img/pricing/lifetime-deal/aiAssistance.png"),
          alt: "ai-assistance",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }